import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MONTH_MODE_FORMATS } from 'app/modules/admin/student/detail/content/eipic-profile/other-services/form/other-services-form.component';

@Component({
  selector: 'month-picker',
  template: `<div class="mb-4">
    <label [for]="controlName" class="block text-sm font-medium text-gray-700"
      >{{ label }}
      <span *ngIf="isRequired() && label !== ''" class="text-red-500"> * </span>
    </label>
    <div
      class="flex h-9 w-full border border-gray-300 px-4 items-center rounded-md"
      [ngClass]="{ 'bg-gray-100': controlName.disabled }"
    >
      <input
        matInput
        [matDatepicker]="date"
        [placeholder]="placeholder"
        [id]="controlName"
        [name]="controlName"
        [formControl]="controlName"
        [readOnly]="true"
      />
      <mat-datepicker-toggle [for]="date" class="ml-auto">
        <mat-icon
          svgIcon="feather:calendar"
          matDatepickerToggleIcon
          class="text-blue-500"
        ></mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker
        #date
        startView="multi-year"
        (monthSelected)="setMonthAndYear($event, date)"
      ></mat-datepicker>
    </div>
    <div
      class="invalid-feedback"
      *ngIf="controlName.invalid && controlName.touched"
    >
      <div
        *ngIf="controlName.errors.required"
        class="text-xs text-red-500 mt-1 ml-2"
      >
        This field is required.
      </div>
    </div>
  </div>`,
  providers: [{ provide: MAT_DATE_FORMATS, useValue: MONTH_MODE_FORMATS }],
})
export class MonthPickerComponent implements OnInit {
  @Input() label: string = '';
  @Input() controlName: FormControl = new FormControl('');
  @Input() placeholder: string = 'MM/YYYY';
  @Output() dateChange: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit(): void {}

  public setMonthAndYear(normalizedMonthAndYear: any, datepicker: any): void {
    const ctrlValue = new Date();
    ctrlValue.setDate(1);
    ctrlValue.setMonth(normalizedMonthAndYear.month());
    ctrlValue.setFullYear(normalizedMonthAndYear.year());

    this.controlName.setValue(ctrlValue);

    this.dateChange.emit(ctrlValue);

    datepicker.close();
  }

  public isRequired(): boolean {
    // check form if they have a required validation
    return this.controlName.hasValidator(Validators.required);
  }
}
